import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentListItemRemovalFailedAction = {
	type: 'DOCUMENT_LIST_ITEM_REMOVAL_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentListItemRemovalFailedAction => ({
	type: 'DOCUMENT_LIST_ITEM_REMOVAL_FAILED',
	payload,
});
